import chroma from 'chroma-js' 

const sizes = {
  xs: "(max-width: 480px)",
  sm: "(max-width: 576px)",
  md: "(max-width: 768px)",
  lg: "(max-width: 992px)",
  xl: "(max-width: 1200px)",
};

const styles = theme => ({
    ColorBox:{
      width : "20%",
      height: props => props.showingFullColorPalette ?"25%":"50%",
      margin : "0 auto",
      display: "inline-block",
      position: "relative",
      cursor: "pointer",
      marginBottom: "-3.5px",
      fontSize: "20px",
      transition: theme.transitions.create(['transform', 'box-shadow'], {
        duration: theme.transitions.duration.shorter,
      }),
      "&:hover": {
        zIndex: "5",
        boxShadow: theme.shadows[8],
      },
      "&:hover button":{
        opacity: 1,
        transform: "scale(1)",
      },
      "&:hover $selectButton": {
        opacity: 1,
      },
      "&:hover $seeMore": {
        opacity: 1,
      },
      [`@media ${sizes.xl}`]: {
        width: "25%",
        height: props => props.showingFullColorPalette ? "20%" : "33.3333%",
      },
      [`@media ${sizes.lg}`]: {
        width: "25%",
        height: props => props.showingFullColorPalette ? "20%" : "33.3333%",
      },
      [`@media ${sizes.md}`]: {
        width: "33.3333%",
        height: props => props.showingFullColorPalette ? "14.2857%" : "25%",
      },
      [`@media ${sizes.sm}`]: {
        width: "50%",
        height: props => props.showingFullColorPalette ? "10%" : "20%",
      },
      [`@media ${sizes.xs}`]: {
        width: "50%",
        height: props => props.showingFullColorPalette ? "10%" : "20%",
      },
    },
    colorName: {
      color : props => chroma(props.background).luminance() <= 0.08 ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.7)",
      fontWeight: "500",
      fontFamily: theme.typography.fontFamily,
      [`@media ${sizes.md}`]: {
        fontSize: "10px",
      },
      [`@media ${sizes.sm}`]: {
        fontSize: "9px",
      },
    },
  
    seeMore :{
      color : props => chroma(props.background).luminance() >= 0.7 ? "rgba(0,0,0,0.7)" : "white",
      background:"rgba(255,255,255,0.2)",
      position:"absolute",
      border :"none",
      right:"0px",
      bottom:"0px",
      width:"60px",
      height:"30px",
      textAlign:"center",
      lineHeight:"30px",
      textTransform:"uppercase",
      borderTopLeftRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('opacity'),
      fontSize: "12px",
      opacity: 0,
      "&:hover": {
        background: "rgba(255,255,255,0.4)",
      },
      [`@media ${sizes.md}`]: {
        width: "50px",
        height: "25px",
        lineHeight: "25px",
        fontSize: "10px",
        opacity: 0.8,
      },
      [`@media ${sizes.sm}`]: {
        width: "45px",
        height: "22px",
        lineHeight: "22px",
        fontSize: "9px",
      },
    },
    boxContent:{
      position: "absolute",
      width: "100%",
      left: "0px",
      bottom: "0px",
      padding: "10px",
      color: props => chroma(props.background).luminance() <= 0.08 ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.7)",
      letterSpacing: "1px",
      textTransform: "uppercase",
      fontSize: "12px",
      fontWeight: "500",
      fontFamily: theme.typography.fontFamily,
      [`@media ${sizes.md}`]: {
        padding: "6px",
        fontSize: "10px",
        letterSpacing: "0.5px",
      },
      [`@media ${sizes.sm}`]: {
        padding: "4px",
        fontSize: "8px",
        letterSpacing: "0",
      },
    },
    // Subtle bottom-center "copied" confirmation, like Coolors.
    toast: {
      position: "fixed",
      bottom: "2rem",
      left: "50%",
      transform: "translateX(-50%) translateY(16px)",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      backgroundColor: "rgba(20,20,20,0.92)",
      color: "#fff",
      padding: "0.55rem 1.1rem",
      borderRadius: "999px",
      fontSize: "0.9rem",
      fontWeight: 500,
      letterSpacing: "normal",
      textTransform: "none",
      fontFamily: theme.typography.fontFamily,
      boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
      opacity: 0,
      pointerEvents: "none",
      zIndex: 2000,
      transition: "opacity 0.2s ease, transform 0.2s ease",
      [`@media ${sizes.sm}`]: {
        fontSize: "0.8rem",
        bottom: "1.25rem",
      },
    },
    toastShow: {
      opacity: 1,
      transform: "translateX(-50%) translateY(0)",
    },
    selectButton: {
      position: "absolute",
      top: "5px",
      right: "5px",
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform', 'background-color']),
      backgroundColor: "rgba(0,0,0,0.3)",
      padding: "4px",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.5)",
        transform: "scale(1.1)",
      },
      [`@media ${sizes.md}`]: {
        top: "3px",
        right: "3px",
        padding: "3px",
        opacity: 0.8,
      },
      [`@media ${sizes.sm}`]: {
        top: "2px",
        right: "2px",
        padding: "2px",
      },
    },
  });
export default styles;
